import React from "react";
import stl from "./tryon.module.scss";

export default function TryonLoading({ color }: { color: string }) {
    return (
        <svg className={stl["loading"]} viewBox="0 0 200 200">
            <circle
                cx="100"
                cy="100"
                r="95"
                strokeWidth="10"
                stroke={color}
                strokeDasharray="418.879 209.44"
                fill="none"
            />
        </svg>
    );
}
